import React from "react";
import Thankyou_header from "./header";
import Thankyou_receipt from "./receipt";

function Thankyou_content(){

    return(
        <div id="thankyou">
            <Thankyou_header />
            <Thankyou_receipt />
        </div>
    );

}

export default Thankyou_content;